<template>
  <a-card>
    <div style="float: right;">
      <div class="table-toolbar">
        <a-button type="primary" @click="onEdit">
          <template #icon>
            <form-outlined />
          </template>
        </a-button>
      </div>
    </div>
    <div class="top">
      <div class="imgBox">
        <img style="width: 100%;height: 100%;" :src="getImg(detail.headShot)" />
      </div>
      <div class="rightBox">
        <div class="topBox">
          <p class="name">{{ detail.name }}</p>
          <p class="nameRight">注册用户：个人用户</p>
        </div>
        <p class="second">{{ detail.sex == '0' ? '男' : '女' }}&nbsp; / {{ detail.age }}岁&nbsp; / {{ detail.yearsService
        }}年工作经验&nbsp; / <dict-render :dict-obj="dictObjs['education_background']" v-if="detail.educationBackground"
            :text="detail.educationBackground"></dict-render>
        </p>
        <p class="second">
          <mail-outlined />&nbsp; {{ detail.emailAddress }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <phone-outlined />&nbsp;
          {{ detail.phoneNumber }}
        </p>
      </div>
    </div>
    <a-descriptions bordered :column="2">
      <a-descriptions-item label="身份证号码">{{ detail.identityCardNumber }}</a-descriptions-item>
      <a-descriptions-item label="是否为应届生">{{ detail.freshGraduate == 0 ? '是' : '否' }}</a-descriptions-item>
      <a-descriptions-item label="出生日期">{{ detail.dateBirth ? detail.dateBirth.split(' ')[0] : '' }}</a-descriptions-item>
      <a-descriptions-item label="现居地">{{ detail.provject }}</a-descriptions-item>
      <a-descriptions-item label="参加工作时间">{{ detail.timeWork ? detail.timeWork.split(' ')[0] : ''
      }}</a-descriptions-item>
      <a-descriptions-item label="详细地址">{{ detail.detailedAddress }}</a-descriptions-item>
      <a-descriptions-item label="个人简介">{{ detail.personalProfile }}</a-descriptions-item>
    </a-descriptions>
  </a-card>
  <UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="getInfo"/>
</template>

<script>
import { dictMixin } from "@/mixins";
import UserModal from './components/UserModal';
import { personalCenterInfo } from "@/api/educationService";
import DictRender from "@/components/other/DictRender";
import { showCity } from "@/utils/util";
import { file_service } from "@/api/adminService";

export default {
  name: "index",
  mixins: [dictMixin],
  components: {
    UserModal, DictRender
  },
  data() {
    return {
      dictNames: 'education_background',
      detail: {},
      listKeyField: "id",
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.getAction({
        url: personalCenterInfo.userDetail
      }).then(res => {
        this.detail = {
          ...res,
          provject: res.prov?showCity(res.prov, res.city, res.dist):''
        }
      })
    },
    onEdit() {
      this.getAction({
        url: personalCenterInfo.detail
      }).then(res => {
        this.onShowModal('userModal', res);
      })
    },
    onShowModal(refName, data = {}) {
      const refEle = this.$refs[refName];
      refEle.form = Object.assign({}, data);
      refEle.visible = true;
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
  }
}
</script>

<style scoped lang="less">
.top {
  overflow: hidden;
  margin-bottom: 10px;

  .imgBox {
    float: left;
    margin-right: 20px;
    width: 100px;
    height: 100px;
  }

  .rightBox {
    float: left;
    color: #333;

    .topBox {
      overflow: hidden;
      padding-bottom: 10px;
      border-bottom: 1px dashed #dedede;

      .name {
        float: left;
        font-weight: 700;
        font-size: 24px;
      }

      .nameRight {
        float: left;
        margin-left: 25px;
        margin-top: 10px;
      }
    }

    .second {
      font-size: 12px;
      margin-top: 10px;
    }
  }
}
</style>
